/*
 * theme-core.js: the old theme's helpers every page needs, none of them jQuery. Loaded on every page before
 * cart-request-helper.js, cart.js and theme.js (layout/theme.liquid).
 * - Cart pub/sub (cart.js, cart-request-helper.js, cart-host-projection.js) and cookies (promotion bar, modals).
 *   Moved here unchanged from vendor.js, which homepage and theme pages no longer load.
 * - theme.wishlist and theme.deferMenuTemplates, moved unchanged from theme.js.
 * - tvMotion: the slide/fade animations jQuery used to give the header, footer and promotion bar.
 */
const PUB_SUB_EVENTS={cartUpdate:"cart-update",quantityUpdate:"quantity-update",variantChange:"variant-change",cartError:"cart-error"};let subscribers={};function subscribe(r,s){return void 0===subscribers[r]&&(subscribers[r]=[]),subscribers[r]=[...subscribers[r],s],function b(){subscribers[r]=subscribers[r].filter(r=>r!==s)}}function publish(r,s){subscribers[r]&&subscribers[r].forEach(r=>{r(s)})}window.PUB_SUB_EVENTS=window.PUB_SUB_EVENTS||PUB_SUB_EVENTS;;function setCookie(e,t,i){let o=new Date;o.setTime(o.getTime()+864e5*i);let n="expires="+o.toUTCString();document.cookie=e+"="+t+";"+n+";path=/;SameSite=None; secure"}function getCookie(e){var t,i,o,n=document.cookie.split(";");for(t=0;t<n.length;t++)if(i=n[t].substr(0,n[t].indexOf("=")),o=n[t].substr(n[t].indexOf("=")+1),(i=i.replace(/^\s+|\s+$/g,""))==e)return unescape(o)}


window.theme = window.theme || {};

theme.wishlist = (function() {
  var initialized = false;

  function read() {
    var stored = null;
    try {
      stored = localStorage.getItem('wishlist');
    } catch (error) {}
    return (stored ? stored.split('+') : []).map(function(handle) {
      return handle.trim();
    }).filter(function(handle, index, handles) {
      return handle && handle !== 'undefined' && handle !== 'null' && handles.indexOf(handle) === index;
    });
  }

  function sync(handles) {
    handles = handles || read();
    document.querySelectorAll('.wishlist[rel]').forEach(function(button) {
      var saved = handles.indexOf(button.getAttribute('rel')) !== -1;
      var label = saved ? (theme.wlRemove || theme.wlAvailable) : theme.wlAdd;
      button.classList.toggle('addto-wishlist', !saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.setAttribute('aria-label', label);
      button.querySelectorAll('span').forEach(function(text) {
        text.textContent = label;
      });
      button.querySelectorAll('.at-icon').forEach(function(icon) {
        icon.classList.remove('at-flip');
        icon.classList.toggle('added', saved);
      });
    });
    document.querySelectorAll('.favCount').forEach(function(counter) {
      counter.textContent = handles.length > 99 ? '99+' : String(handles.length);
      counter.classList.toggle('hide', handles.length === 0);
    });
    document.querySelectorAll('[data-wishlist-link]').forEach(function(link) {
      var label = link.getAttribute('data-wishlist-label');
      link.setAttribute('aria-label', label + (handles.length ? ' (' + handles.length + ')' : ''));
    });
  }

  function write(handles) {
    try {
      if (handles.length) {
        localStorage.setItem('wishlist', handles.join('+'));
      } else {
        localStorage.removeItem('wishlist');
      }
    } catch (error) {
      // Storage full or blocked: show the hearts as what is actually saved, not what the click asked for.
      handles = read();
    }
    sync(handles);
    return handles;
  }

  function add(handle) {
    var handles = read();
    if (!handle || handle === 'undefined' || handle === 'null') return handles;
    if (handles.indexOf(handle) === -1) handles.push(handle);
    return write(handles);
  }

  function remove(handle) {
    return write(read().filter(function(saved) { return saved !== handle; }));
  }

  function init() {
    if (!initialized) {
      initialized = true;
      // The heart toggles: a saved product is removed on the next click (the wishlist page stays in the header).
      document.addEventListener('click', function(event) {
        var button = event.target.closest('.wishlist[rel]');
        if (!button) return;
        event.preventDefault();
        var handle = button.getAttribute('rel');
        if (read().indexOf(handle) !== -1) {
          remove(handle);
        } else {
          add(handle);
        }
      });
    }
    sync();
  }

  return { read: read, add: add, remove: remove, sync: sync, init: init };
})();

theme.deferMenuTemplates=function(){var containers=document.querySelectorAll("[data-deferred-menu]");if(!containers.length){return}var hoverMedia=window.matchMedia&&window.matchMedia("(hover: hover) and (pointer: fine)");containers.forEach(function(container){var template=container.querySelector("template");if(!template){return}var parentItem=container.closest("li.lvl1.parent");var trigger=parentItem?parentItem.querySelector("a"):null;var handler=function(){if(!template.content){return}var content=template.content.cloneNode(!0);if(container.tagName&&container.tagName.toLowerCase()==="li"){var parent=container.parentNode;if(parent){parent.insertBefore(content,container);parent.removeChild(container)}}else{var placeholder=container.querySelector("[data-deferred-placeholder]");if(placeholder){placeholder.remove()}container.appendChild(content)}template.remove();if(window.lazySizes&&window.lazySizes.loader&&typeof window.lazySizes.loader.checkElems==="function"){window.lazySizes.loader.checkElems()}};if(trigger){if(hoverMedia&&hoverMedia.matches){trigger.addEventListener("mouseenter",handler,{once:!0})}trigger.addEventListener("focus",handler,{once:!0});trigger.addEventListener("touchstart",handler,{once:!0,passive:!0});trigger.addEventListener("click",handler,{once:!0})}else{container.addEventListener("mouseenter",handler,{once:!0});container.addEventListener("focusin",handler,{once:!0});container.addEventListener("touchstart",handler,{once:!0,passive:!0});container.addEventListener("click",handler,{once:!0})}})}

window.tvMotion = (function() {
  function isHidden(el) {
    return getComputedStyle(el).display === 'none';
  }

  function finish(el, animation, done) {
    animation.onfinish = function() {
      done();
      animation.cancel();
    };
  }

  function slideUp(el, duration) {
    if (!el || isHidden(el)) return;
    var height = el.offsetHeight;
    var animation = el.animate([{ height: height + 'px', overflow: 'hidden' }, { height: '0px', paddingTop: '0px', paddingBottom: '0px', overflow: 'hidden' }], duration || 400);
    finish(el, animation, function() { el.style.display = 'none'; });
  }

  function slideDown(el, duration) {
    if (!el || !isHidden(el)) return;
    el.style.display = '';
    if (isHidden(el)) el.style.display = 'block';
    var height = el.offsetHeight;
    el.animate([{ height: '0px', paddingTop: '0px', paddingBottom: '0px', overflow: 'hidden' }, { height: height + 'px', overflow: 'hidden' }], duration || 400);
  }

  function slideToggle(el, duration) {
    if (!el) return;
    if (isHidden(el)) slideDown(el, duration); else slideUp(el, duration);
  }

  function fadeOut(el, duration) {
    if (!el || isHidden(el)) return;
    var animation = el.animate([{ opacity: 1 }, { opacity: 0 }], duration || 400);
    finish(el, animation, function() { el.style.display = 'none'; });
  }

  return { slideUp: slideUp, slideDown: slideDown, slideToggle: slideToggle, fadeOut: fadeOut };
})();
